import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  readonly title?: string | undefined;
  readonly body: string;
  readonly action?: ReactNode | undefined;
  /** Dashed outline variant used inside a populated panel. */
  readonly boxed?: boolean | undefined;
}

export function EmptyState({ title, body, action, boxed }: EmptyStateProps) {
  return (
    <div className={`${styles.empty} ${boxed ? styles.boxed : ''}`}>
      {title ? <p className={styles.title}>{title}</p> : null}
      <p className={styles.body}>{body}</p>
      {action}
    </div>
  );
}
